import { default as getApplicationSettings } from '../../selectors/getApplicationSettings';
import { ResolverEnabledFor } from './ResolverEnabledFor';
import { FeatureName, isFeatureEnabled } from 'owa-feature-flags';

const IndividualResolverFeatureMappings = new Map([
    ['markItemAsRead', 'fwk-useoutlookgateway-markItemAsRead'],
]);

export type ResolverEnabledSettings = {
    Query: { [k: string]: ResolverEnabledFor };
    Mutation: { [k: string]: ResolverEnabledFor };
    Subscription: { [k: string]: ResolverEnabledFor };
};

export function enabledForWeb(op: string, resolver: string) {
    const enabled = getEnabled(op, resolver);
    return (enabled & ResolverEnabledFor.Web) == ResolverEnabledFor.Web;
}

export function enabledForIdb(op: string, resolver: string) {
    const enabled = getEnabled(op, resolver);
    return (enabled & ResolverEnabledFor.Idb) == ResolverEnabledFor.Idb;
}

export function enabledForRemote(op: string, resolver: string) {
    const enabled = getEnabled(op, resolver);
    return (enabled & ResolverEnabledFor.Remote) == ResolverEnabledFor.Remote;
}

// The following function determines whether or not the resolver will go through the Outlook Gateway or not
// If you want the resolver to have a scorecard during the roll-out, please create a client-side flight, add the mapping to the IndividualResolverFeatureMappings list
// If you do this, it will ignore any setting related to this resolver name in the ECS setting.
// After the resolver API is graduated, you can move it to ECS to act a killswitch.
// If you do not want the resolver to have a scorecard during the rollout, you can add the configuration of the resolver to ECS directly.
function getEnabled(op: string, resolver: string) {
    const defaultEnabled = ResolverEnabledFor.All;

    if (IndividualResolverFeatureMappings.has(resolver)) {
        let featureName = IndividualResolverFeatureMappings.get(resolver);
        if (featureName) {
            return isFeatureEnabled(featureName as FeatureName)
                ? ResolverEnabledFor.Remote
                : defaultEnabled;
        }
    }

    if (
        !isFeatureEnabled('fwk-graphql-resolvers-config') ||
        !isFeatureEnabled('fwk-application-settings')
    ) {
        return defaultEnabled;
    } else {
        const resolverLocations = getApplicationSettings('EnabledResolvers');
        const configuredEnabled = resolverLocations?.[op]?.[resolver];
        return configuredEnabled == undefined ? defaultEnabled : configuredEnabled;
    }
}
